import { get } from "./api";

export type DashboardRow = {
  memberId: string;
  fullName: string;
  department: string | null;
  status: "not_started" | "in_progress" | "submitted" | "pending_grading" | "completed";
  scorePercent: number | null;
  passed: boolean | null;
};

export type RankingEntry = {
  memberId: string;
  fullName: string;
  scorePercent: number;
  durationSeconds: number;
};

export type DashboardResponse = {
  charts: {
    completionBreakdown: { status: string; count: number }[];
    scoreDistribution: { bucket: string; count: number }[];
    avgScoreByDepartment: { department: string; averageScorePercent: number }[];
  };
  table: DashboardRow[];
  ranking: RankingEntry[];
};

function withDepartments(path: string, departments: string[]) {
  if (departments.length === 0) return path;
  const qs = departments.map((d) => `department=${encodeURIComponent(d)}`).join("&");
  return `${path}?${qs}`;
}

export function getManagerDashboard(departments: string[] = []) {
  return get<DashboardResponse>(withDepartments("/manager/dashboard", departments));
}

export function getCompanyDashboard(companyId: string, departments: string[] = []) {
  return get<DashboardResponse>(
    withDepartments(`/co/companies/${encodeURIComponent(companyId)}/dashboard`, departments),
  );
}

export function getMemberResultForManager(memberId: string) {
  return get<{
    status: string;
    scorePercent: number | null;
    passed: boolean | null;
    questions: Array<{
      questionId: string;
      text: string;
      given: string[] | string | null;
      isCorrect: boolean | null;
      correctAnswer?: string[] | null;
      explanationHtml?: string;
    }>;
  }>(`/manager/members/${encodeURIComponent(memberId)}/result`);
}

export function getMyRanking() {
  return get<{ ranking: RankingEntry[] }>("/me/ranking");
}
